import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOmeMeetDateValidationData  from './GetOmeMeetDateValidationData';

export const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const OmeMeetDateValidationData = {
  getOmeMeetDateValidationData,
  INITIAL_STATE
};

export default OmeMeetDateValidationData;